import { Component, OnInit } from '@angular/core';
import { DutyPaymentsService } from 'src/app/services/payments/duty-payments.service';

@Component({
  selector: 'app-paid-duties-pending-receipt-attachment',
  templateUrl: './paid-duties-pending-receipt-attachment.component.html',
  styleUrls: ['./paid-duties-pending-receipt-attachment.component.css']
})
export class PaidDutiesPendingReceiptAttachmentComponent implements OnInit {
  page: number = 1;
  count: number = 0;
  paid_duties:any[] = [];
  searchText: string = '';
  isLoading: boolean = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;
  selectedUnofficialPayments: any[] = []; // Array to store selected duties

  constructor(private dutyPaymentsService: DutyPaymentsService){}

  ngOnInit(): void {
    this.isLoading=true;
    this.getPaidDutiesPendingReceiptAttachments();
  }

  /**
   * Get all paid duties
   * pending receipt attachments
   */
  getPaidDutiesPendingReceiptAttachments()
  {
    this.dutyPaymentsService.getPaidDutiesPendingReceiptAttachments().subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.isLoading = false;
          this.paid_duties=response.data
        }else{
          this.isLoading = false;
          this.errorMessage=response.message;
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.errorMessage=error;
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
    this.getPaidDutiesPendingReceiptAttachments();
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }

  // Function to handle checkbox change event
  checkboxChange(event: any, item: string) {
    if (event.target.checked) {
      this.selectedUnofficialPayments.push(item)
    }else{
      // Remove unchecked item from the array
      const index = this.selectedUnofficialPayments.indexOf(item);
      if (index !== -1) {
        this.selectedUnofficialPayments.splice(index, 1);
      }
    }
  }

  isSelected(item: any): boolean {
    return this.selectedUnofficialPayments.includes(item);
  }

  markAsNoReceiptRequired(){
    if(this.selectedUnofficialPayments.length===0){
      this.errorMessage="Please select unofficial payments that don’t require receipts!";
      this.successMessage=null;
    }else{
      this.isLoading=true;
      this.dutyPaymentsService.markAsNoReceiptRequired(this.selectedUnofficialPayments)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.successMessage=response.message;
            this.errorMessage=null;
            //Clear Unofficial Payments array
            this.selectedUnofficialPayments.length = 0;
            // Refresh to the list
            this.getPaidDutiesPendingReceiptAttachments();
          }else{
            this.isLoading=false;
            this.errorMessage=response.message;
          }
        },
        error: (error) => {
          this.isLoading=false;
          // Handle the error
          console.error('Error clearing unofficial payments that don\'t require receipts:', error);
          this.errorMessage="An Error occurred while clearing unofficial payments that don\'t require receipts. Please try again!";
        }
      });
    }
  }
}
